import { useBrowser } from "@stepapp/core";
import { TypographyVariants } from "@stepapp/ui";
import { useRouter } from "expo-router";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppLinks } from "../../hooks";
import { AppStorage } from "../../services/AppStorage";
import { useDisplayIntercom } from "../../services/Intercom";
import { useLogout } from "./useLogout";

export type NavigationItem = {
  label: string;
  onPress: () => void;
  font?: TypographyVariants;
};

export const useNavigationItems = () => {
  const { t } = useTranslation();
  const { navigate } = useRouter();
  const { AboutUs } = useAppLinks();
  const countryCode = AppStorage().get("countryCode");
  const displayIntercom = useDisplayIntercom(countryCode);
  const isAuthenticated = !!AppStorage().get("token");
  const [shareCouponVisible, setShareCouponVisible] = useState(false);

  const handleLogOut = useLogout();
  const openAboutStepapp = useBrowser(AboutUs);

  const navigationItems = useMemo(() => {
    if (isAuthenticated) {
      return [
        {
          label: t("components.header.showProfile"),
          onPress: () => navigate("/profile"),
        },
        {
          label: t("components.header.payments"),
          onPress: () => navigate("/payments"),
        },
        {
          label: t("components.header.settings"),
          onPress: () => navigate("/settings"),
        },
        {
          label: t("components.header.coupons"),
          onPress: () => navigate("/coupons"),
        },
        {
          label: t("components.header.inviteFriends"),
          font: "paragraphBold" as TypographyVariants,
          onPress: () => setShareCouponVisible(true),
        },
        {
          label: t("components.header.writeToUs"),
          onPress: () => navigate("/support"),
        },
        {
          label: t("components.header.help"),
          onPress: displayIntercom,
        },
        {
          label: t("screens.settings.logOut"),
          onPress: handleLogOut,
        },
      ];
    }

    return [
      {
        label: t("components.header.signIn"),
        onPress: () => navigate("/login/phone"),
      },
      {
        label: t("components.header.aboutStepapp"),
        onPress: openAboutStepapp,
      },
      {
        label: t("components.header.writeToUs"),
        onPress: () => navigate("/support"),
      },
      {
        label: t("components.header.help"),
        onPress: displayIntercom,
      },
    ];
  }, [isAuthenticated, t, navigate, handleLogOut, openAboutStepapp, displayIntercom]);

  return {
    navigationItems,
    shareCouponVisible,
    setShareCouponVisible,
  };
};
